module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading === 1) ? _c('loading', {
    staticStyle: {
      "min-height": "620px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading === 0),
      expression: "loading === 0"
    }]
  }, [((_vm.evaluate_result.abilities && _vm.evaluate_result.abilities.length > 0) || (_vm.evaluate_result.tags && _vm.evaluate_result.tags.length > 0) || (_vm.evaluate_result.indicators && _vm.evaluate_result.indicators.length > 0)) ? _c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    staticClass: "m-b-sm"
  }, [_c('span', [_vm._v(_vm._s(_vm.questionnaire.score_name) + "测评报告")]), _vm._v(" "), (_vm.questionnaire.category === 2) ? _c('span', {
    staticClass: "btn btn-primary right",
    on: {
      "click": function($event) {
        _vm.download()
      }
    }
  }, [_vm._v("下载报告")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "b-b"
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "report-area"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h1', {
    staticClass: "p-t-b-md n-m-b text-center"
  }, [_vm._v(_vm._s(_vm.questionnaire.score_name) + "测评报告")])]), _vm._v(" "), _c('div', {
    staticClass: "row user-info snapshort"
  }, [(_vm.questionnaire.category === 2) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.tester.realname ? _vm.tester.realname : _vm.tester.nickname))])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("邮箱:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.tester.email))])]), _vm._v(" "), (_vm.tester.phone) ? _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("手机:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.tester.phone))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.tester.avatar) ? _c('img', {
    staticClass: "m-r-sm right",
    attrs: {
      "src": _vm.tester.avatar,
      "alt": "",
      "width": "100"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "b-b m-t-b-sm "
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("得分:")]), _vm._v(" "), _c('span', {
    staticClass: "info num"
  }, [_vm._v(_vm._s(_vm.evaluate_result.score.toFixed(2)))])])]), _vm._v(" "), (_vm.evaluate_result.grade && _vm.evaluate_result.grade.desc) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "label p-b-sm"
  }, [_vm._v("总结：")]), _vm._v(" "), _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.evaluate_result.grade && _vm.evaluate_result.grade.desc)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.evaluate_result.grade && _vm.evaluate_result.grade.suggestion) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "label p-b-sm"
  }, [_vm._v("建议：")]), _vm._v(" "), _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.evaluate_result.grade && _vm.evaluate_result.grade.suggestion)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.evaluate_result.grade && _vm.evaluate_result.grade.improvement) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "label p-b-sm"
  }, [_vm._v("提升：")]), _vm._v(" "), _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.evaluate_result.grade && _vm.evaluate_result.grade.improvement)
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "b-b m-t-b-sm "
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row snapshort m-b-sm"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "label p-b-sm"
  }, [_vm._v("总分:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "dimension",
    class: _vm.tag_class
  }, [_c('div', {
    staticClass: "row name"
  }, [_vm._v(_vm._s(_vm.evaluate_result.score_name))]), _vm._v(" "), _c('div', {
    staticClass: "row score"
  }, [_vm._v(_vm._s(_vm.evaluate_result.score.toFixed(2)))])]), _vm._v(" "), _vm._l((_vm.evaluate_result.tags), function(tag) {
    return _c('div', {
      key: tag._id,
      staticClass: "dimension",
      class: _vm.tag_class
    }, [_c('div', {
      staticClass: "row name"
    }, [_vm._v(_vm._s(tag.name))]), _vm._v(" "), _c('div', {
      staticClass: "row score"
    }, [_vm._v(_vm._s(tag.score.toFixed(2)))])])
  })], 2)]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "label p-b-sm"
  }, [_vm._v("维度得分:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.evaluate_result.indicators), function(indicator) {
    return _c('div', {
      key: indicator._id,
      staticClass: "dimension",
      class: _vm.indicator_class
    }, [_c('div', {
      staticClass: "row name"
    }, [_vm._v(_vm._s(indicator.name))]), _vm._v(" "), _c('div', {
      staticClass: "row score"
    }, [_vm._v(_vm._s(indicator.score.toFixed(2)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.aspect_radars), function(radar_data) {
    return _c('radar', {
      key: radar_data.name,
      class: {
        'col-xs-12': _vm.aspect_radars.length === 1, 'col-xs-6': _vm.aspect_radars.length !== 1
      },
      staticStyle: {
        "height": "350px"
      },
      attrs: {
        "title": radar_data.title,
        "legend": radar_data.legend,
        "series": radar_data.series,
        "indicator": radar_data.indicator
      }
    })
  }))])])])]), _vm._v(" "), _vm._l((_vm.evaluate_result.aspects), function(aspect, ind) {
    return _c('div', {
      key: aspect._id,
      staticClass: "row snapshot ability open",
      class: {
        'open': aspect.is_open === 1
      },
      attrs: {
        "data-index": ind
      }
    }, [_c('div', {
      staticClass: "col-xs-12 m-b-sm "
    }, [_c('div', {
      staticClass: "btn btn-md n-b-r col-xs-12 n-f btn-success"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-3 col-xs-12"
    }, [_c('span', [_vm._v("能力名称：")]), _vm._v(" "), _c('span', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(aspect.name))])])])]), _vm._v(" "), _c('div', {
      staticClass: "detail col-xs-12"
    }, [_c('div', {
      staticClass: "row p-b-sm"
    }, [(aspect.desc) ? _c('div', {
      staticClass: "col-xs-12",
      class: {
        'col-sm-6': !aspect.grade, 'col-sm-4': aspect.grade
      }
    }, [_c('div', {
      staticClass: "row p-l-r-xs"
    }, [_c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(aspect.desc)
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      class: {
        'col-sm-6': aspect.grade || aspect.desc, 'col-sm-4': aspect.grade && aspect.desc
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('Scatter', {
      staticClass: "col-xs-12 n-p-l n-p-r",
      staticStyle: {
        "height": "200px"
      },
      attrs: {
        "code": _vm.code,
        "type": 3,
        "target": aspect._id,
        "name": aspect.name,
        "score": aspect.score
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 m-t-xs text-center p-b-xs",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('span', [_c('i', {
      staticClass: "score"
    }, [_vm._v(_vm._s(aspect.score.toFixed(2)))]), _vm._v("分")])])], 1)]), _vm._v(" "), (aspect.grade) ? _c('div', {
      staticClass: "col-xs-12 col-sm-4"
    }, [(aspect.grade.desc) ? _c('div', {
      staticClass: "row p-b-sm"
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding-left": "5px"
      }
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("解析：")]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(aspect.grade.desc)
      }
    })])]) : _vm._e(), _vm._v(" "), (aspect.grade.suggestion) ? _c('div', {
      staticClass: "row p-b-sm"
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding-left": "5px"
      }
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("建议：")]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(aspect.grade.suggestion)
      }
    })])]) : _vm._e(), _vm._v(" "), (aspect.grade.improvement) ? _c('div', {
      staticClass: "row p-b-sm"
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding-left": "5px"
      }
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("提升：")]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(aspect.grade.improvement)
      }
    })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "b-b m-b-xs"
    })]), _vm._v(" "), _c('div', {
      staticClass: "row p-b-sm"
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l((aspect.indicators), function(indicator) {
      return _c('div', {
        key: indicator._id,
        staticClass: "indicator col-xs-12",
        class: {
          'col-sm-4': aspect.indicators.length >= 3, 'col-sm-6': aspect.indicators.length <= 2
        }
      }, [_c('Scatter', {
        staticClass: "col-xs-12 n-p-l n-p-r",
        staticStyle: {
          "height": "200px"
        },
        attrs: {
          "code": _vm.code,
          "type": 1,
          "target": indicator.indicator.indicator,
          "name": indicator.indicator.name,
          "score": indicator.indicator.score,
          "rate": indicator.rate
        }
      }), _vm._v(" "), (_vm.questionnaire.category === 2) ? _c('time-scatter', {
        staticClass: "col-xs-12 n-p-l n-p-r",
        staticStyle: {
          "height": "200px"
        },
        attrs: {
          "code": _vm.code,
          "type": 1,
          "target": indicator.indicator.indicator,
          "name": indicator.indicator.name,
          "score": indicator.indicator.duration,
          "rate": indicator.rate
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 m-t-xs text-center p-b-xs",
        staticStyle: {
          "font-size": "14px"
        }
      }, [_c('span', {
        staticClass: "score"
      }, [_vm._v(_vm._s(indicator.indicator.score.toFixed(2)) + "分")]), _vm._v(",领先\n                        "), _c('span', {
        staticClass: "score"
      }, [_vm._v(_vm._s((indicator.indicator.rate * 100).toFixed(2)) + "%")]), _vm._v("的测评用户")]), _vm._v(" "), (indicator.indicator.grade_desc) ? _c('div', {
        staticClass: " p-t-b-sm"
      }, [_c('div', {
        staticClass: "col-xs-12"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "label m-b-xs"
      }, [_vm._v("指标解析：")]), _vm._v(" "), _c('div', {
        staticClass: "desc",
        domProps: {
          "innerHTML": _vm._s(indicator.indicator.grade_desc)
        }
      })])])]) : _vm._e()], 1)
    }))])])])])
  }), _vm._v(" "), _vm._m(3)], 2)])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 m-t-b-sm"
  }, [_c('div', {
    staticStyle: {
      "height": "20px",
      "background": "#42b983"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('img', {
    staticClass: "psych-logo left",
    attrs: {
      "src": "/assets/images/psych2_4_2.jpg",
      "alt": "",
      "height": "60"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('img', {
    staticClass: "lechenggu-logo left right",
    attrs: {
      "src": "/assets/images/lechenggu-logo.png",
      "alt": "",
      "height": "60"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": "bar-area"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b-b m-b-sm "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_c('span', [_vm._v("本报告由")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "href": "http://www.psych.cas.cn",
      "title": "中国科学院心理研究所·心理健康应用中心",
      "alt": "中国科学院心理研究所·心理健康应用中心"
    }
  }, [_vm._v("中国科学院心理研究所·心理健康应用中心")]), _vm._v(" "), _c('span', [_vm._v("提供测评技术支持")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18fb7062","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/evaluate/report/dimension.vue
// module id = 465
// module chunks = 1